// names come from cloudflare zaraz integration
// https://dash.cloudflare.com/21fdbaca81d5ccb63c94b653446f7269/tag-management/zaraz/blockworks.co/tools-config/triggers
export enum ZarazTrackEvent {
    FacebookCompleteNewsletterRegistration = 'facebook_complete_newsletter_registration',
    XCompleteNewsletterRegistration = 'x_complete_newsletter_registration',
}
